import React, { useContext } from "react";
import { LanguageContext, text } from "../../container/language";

import data from "./data";
import "./style.scss"

const SmallHero = ({ data }) => {
    const { userLanguage } = useContext(LanguageContext)
    const { title, subtitle, mobileScreen, desktopScreen, textColor } = data
    return (
        <div className="header-overlap">
            <a href="javascript:;">
                <div className="header-overlap__text">
                    <div className="header-overlap__title" style={{color: textColor || "white"}}>
                        <font><font>{text(title, userLanguage)}</font></font>
                    </div>
                    <p style={{color: textColor || "white"}}>
                        <font><font>{text(subtitle, userLanguage)}</font></font>
                    </p>
                </div>
                <div className="header-overlap__image object-fit-container">
                    <picture>
                        <source srcset={desktopScreen.url} media="(min-width: 48em)" />
                        <img srcset={mobileScreen.url} />
                    </picture>
                </div>
            </a>
        </div>
    )
}

export default SmallHero;